import { accountService } from "../_services/accounts.service";
export interface IPrimaryNavInterface {
    icon: string;
    name: string;
    mobileName?: string;
    url: string;
    onClick?: any;
    png?: string;
}

const PRIMARY_NAV: IPrimaryNavInterface[] = [
    { icon: 'home', name: 'Dashboard', mobileName: 'Dashboard', url: 'Newsfeed' },

];

const CLIENTS_NAV: IPrimaryNavInterface[] = [
    { icon: 'people', name: 'Clients', mobileName: 'Clients', url: 'Client' },

]

const CENTRES_NAV: IPrimaryNavInterface[] = [
    { icon: 'local_hospital', name: 'Centre', mobileName: 'Centre', url: 'Centre' },

]

const FORMS_NAV: IPrimaryNavInterface[] = [
    { icon: 'article', name: 'Form Templates', mobileName: 'Form Templates', url: 'FormTemplates' },
   
];

const FORMS_APPROVALS_NAV: IPrimaryNavInterface[] = [
     { icon: 'thumb_up_alt', name: 'Form Approvals', mobileName: 'Form Approvals', url: 'FormApprovals' },
]
const DOCUMENTS_NAV: IPrimaryNavInterface[] = [
    { icon: 'file_copy', name: 'Resource Documents', mobileName: 'Resource Documents', url: 'ResourceDocuments' },
     { icon: 'file_copy', name: 'Policy Documents', mobileName: 'Policy Documents', url: 'PolicyDocuments' },
];

const ADMIN_NAV: IPrimaryNavInterface[] = [
    { icon: 'book', name: 'Logs', mobileName: 'Logs', url: 'Logs' },
    { icon: 'groups', name: 'Users', mobileName: 'Users', url: 'Users' },
    { icon: 'accessibility', name: 'Body Type', mobileName: 'Body Type', url: 'BodyType' },
    { icon: 'monitor_heart', name: 'Care Status', mobileName: 'Care Status', url: 'CareStatus' },
    { icon: 'phone', name: 'Centre Contact Types', mobileName: 'Centre Contact Types', url: 'CentreContactType' },
    { icon: 'contact_phone', name: 'Client Contact Types', mobileName: 'Client Contact Types', url: 'ClientContactTypes' },
    { icon: 'person_add', name: 'Complexions', mobileName: 'Complexions', url: 'Complexion' },
    { icon: 'flag', name: 'Counties', mobileName: 'Counties', url: 'County' },
    { icon: 'person_off', name: 'Deleted Clients', mobileName: 'Deleted Clients', url: 'DeletedClient' },
    { icon: 'travel_explore', name: 'Ethnic Origins', mobileName: 'Ethnic Origins', url: 'EthnicOrigins' },
    { icon: 'event', name: 'Events', mobileName: 'Events', url: 'Event' },
    { icon: 'visibility', name: 'Eye Colours', mobileName: 'Eye Colours', url: 'EyeColours' },
    { icon: 'transgender', name: 'Genders', mobileName: 'Genders', url: 'Gender' },
    { icon: 'face_1', name: 'Hair Colours', mobileName: 'Hair Colours', url: 'HairColours' },
    { icon: 'newspaper', name: 'News', mobileName: 'News', url: 'News' },
    { icon: 'library_books', name: 'News Categories', mobileName: 'News Categories', url: 'NewsCategory' },






];



const USER_NAV: IPrimaryNavInterface[] = [
    { icon: 'logout', name: 'Log Out', url: 'logout', onClick: accountService.logout },
];



const UPLOADS_NAV: IPrimaryNavInterface[] = [
];


export {
    PRIMARY_NAV,
    CLIENTS_NAV,
    CENTRES_NAV,
    ADMIN_NAV,
    USER_NAV,
    UPLOADS_NAV,
    FORMS_NAV,
    DOCUMENTS_NAV,
    FORMS_APPROVALS_NAV
};

